module.exports = __webpack_public_path__ + "static/media/logo.d05c68cf.png";